import { Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { SettlementStatusEnum } from "@saleor/types/globalTypes";
import React from "react";
import { FormattedMessage } from "react-intl";

import { FinanceOrderListUrlQueryParams } from "../../urls";

const useStyles = makeStyles(
  () => ({
    btnLabel: {
      color: "#fff"
    },
    negativeBtn: {
      backgroundColor: "#EC5D77",
      ...{
        "&:hover": {
          backgroundColor: "#CD5C5C"
        }
      }
    },
    positiveBtn: {
      backgroundColor: "#4caf50",
      ...{
        "&:hover": {
          backgroundColor: "#388e3c"
        }
      }
    }
  }),
  { name: "createToolBar" }
);

const createToolBar = (
  openModal: (
    action: string,
    newParams?: FinanceOrderListUrlQueryParams
  ) => void,
  status: SettlementStatusEnum
) => {
  const classes = useStyles({});

  switch (status) {
    case SettlementStatusEnum.OPEN:
      return (
        <>
          <Button
            className={classes.positiveBtn}
            color="primary"
            onClick={() => openModal("for-payment")}
          >
            <div className={classes.btnLabel}>
              <FormattedMessage
                defaultMessage="FOR PAYMENT"
                description="for payment batch"
              />
            </div>
          </Button>
          <Button
            className={classes.negativeBtn}
            color="primary"
            onClick={() => openModal("exclude")}
          >
            <div className={classes.btnLabel}>
              <FormattedMessage
                defaultMessage="EXCLUDE"
                description="exclude batch"
              />
            </div>
          </Button>
        </>
      );
    case SettlementStatusEnum.FOR_PAYMENT:
      return (
        <>
          <Button
            className={classes.negativeBtn}
            color="primary"
            onClick={() => openModal("return")}
          >
            <div className={classes.btnLabel}>
              <FormattedMessage
                defaultMessage="Return to Open Orders"
                description="return to open orders"
              />
            </div>
          </Button>
        </>
      );
    case SettlementStatusEnum.EXCLUDED:
      return (
        <>
          <Button
            className={classes.positiveBtn}
            variant="contained"
            onClick={() => openModal("return")}
          >
            <div className={classes.btnLabel}>
              <FormattedMessage
                defaultMessage="Return to Open Orders"
                description="return to open orders"
              />
            </div>
          </Button>
        </>
      );
    default:
      break;
  }
};

export default createToolBar;
